import { type Child, h } from '../dom.ts';

export function openModal(
  title: string,
  content: Child,
  actions: HTMLElement[],
): () => void {
  const close = () => overlay.remove();
  const overlay = h(
    'div',
    {
      class: 'overlay',
      onclick: (e: Event) => {
        if (e.target === overlay) close();
      },
    },
    h(
      'div',
      { class: 'modal', role: 'dialog', 'aria-label': title },
      h(
        'header',
        null,
        h('h3', null, title),
        h('button', {
          class: 'ghost icon',
          onclick: close,
          'aria-label': 'Fermer',
        }, '×'),
      ),
      h('div', { class: 'modal-body' }, content),
      h('footer', null, actions),
    ),
  );
  document.body.appendChild(overlay);
  return close;
}
